import { UserTable } from "widgets/user-table";

export function UserPage() {
  return <UserTable></UserTable>;
}
